// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__wy2AS","subheader":"ReorderModal_subheader__stGEb","listWrap":"ReorderModal_listWrap__3qsQt"};